export default __webpack_public_path__ + "static/Primary Logo-black-1000px-c692c146059f0f25ace91d7461178da7.png";